import ServiceCardV2 from '../ServiceCardV2'
import './styles.scss'

import missionIcon from '../../Assets/Images/mission-icon.png'
import vissionIcon from '../../Assets/Images/vision-icon.png'
import contactUsIcon from '../../Assets/Images/contact-us-icon.png'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../../constants'

const UnbeatableSection = () => {
  const navigate = useNavigate()

  const goToAboutUs = () => navigate(ROUTES.about)

  const goToContactUs = () => navigate(ROUTES.contact)

  const goToTrackIt = () => navigate(ROUTES.trackIt)

  return (
    <section className="unbeatable-section">
      <div className="info">
        <h2>End-to-End Logistics Solutions</h2>

        <p>
          From first mile to final delivery, Sapphirre Bridge Logistics manages
          every step of your supply chain with precision, transparency, and care
          — across air, ocean, road, and warehousing.
        </p>
      </div>

      <div className="service-cards">
        <ServiceCardV2
          label="Track Shipment"
          icon={<img src={missionIcon} />}
          onClick={goToTrackIt}
        />

        <ServiceCardV2
          label="About Us"
          icon={<img src={vissionIcon} />}
          onClick={goToAboutUs}
        />

        <ServiceCardV2
          label="Contact Us"
          icon={<img src={contactUsIcon} />}
          onClick={goToContactUs}
        />
      </div>
    </section>
  )
}

export default UnbeatableSection
